(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const $ = window.jQuery;

$(() => {
  $(function () {
    function checkDropdownOverflow() {
      $(".header-menu-dropdown").each(function () {
        const dropdown = $(this);
        dropdown.removeClass("header-menu-dropdown--collision");

        const leftPosition = dropdown.offset().left;
        const dropdownWidth = dropdown.outerWidth();
        const windowWidth = $(window).width();

        const isEntirelyVisible = leftPosition + dropdownWidth <= windowWidth;

        if (isEntirelyVisible === false) {
          dropdown.addClass("header-menu-dropdown--collision");
        }
      });
    }

    checkDropdownOverflow();

    $(window).on("resize", function () {
      checkDropdownOverflow();
    });
  });
});

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/_menu-dropdown.js","/")